var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_VideoFile_36dp",
    "data-name": "Icon/VideoFile/36dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "aspect_ratio-black-36dp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0,0H36V36H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M30,30H6a3,3,0,0,1-3-3V9A3,3,0,0,1,6,6H30a3,3,0,0,1,3,3V27A3,3,0,0,1,30,30ZM15,11.818a1,1,0,0,0-1,1V23.18a1,1,0,0,0,1.54.84l8.14-5.18A.989.989,0,0,0,24.145,18a1.006,1.006,0,0,0-.465-.854l-8.14-5.17A1,1,0,0,0,15,11.818Z",
    fill: "#ff5427"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoSmall);
export default __webpack_public_path__ + "static/media/video-small.0a38557fea36d7c4a346a9dd1c1980cc.svg";
export { ForwardRef as ReactComponent };